import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export const GuaranteeSection = () => {
  return <section className="py-16 px-4 bg-orange-900/20 border-y border-orange-500/30" data-id="element-148">
      <div className="max-w-3xl mx-auto text-center" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-black border-2 border-orange-500 rounded-2xl p-8 md:p-12 shadow-[0_0_40px_rgba(249,115,22,0.15)]" data-id="element-150">
          <ShieldCheck className="w-20 h-20 text-orange-500 mx-auto mb-6" data-id="element-151" />
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-6" data-id="element-152">
            🛡️ GARANTÍA 7 DÍAS SIN PREGUNTAS
          </h2>
          <p className="text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-153">
            Probalo 7 días. Si no te sirve, te devolvemos el 100%.
          </p>
          <p className="text-lg text-gray-400 mb-8" data-id="element-154">
            Sin formularios. Sin vueltas. Un mensaje a{' '}
            <a href="mailto:compradigitalyaa@gmail.com" className="text-orange-500 hover:underline" data-id="element-155">
              compradigitalyaa@gmail.com
            </a>{' '}
            y listo.
          </p>
          <div className="inline-block bg-gray-900 border border-orange-500/50 rounded-full px-6 py-3" data-id="element-156">
            <p className="text-white font-bold" data-id="element-157">
              El riesgo no es tuyo. Es nuestro.{' '}
              <span className="text-orange-500" data-id="element-158">
                Tasa de devoluciones: menos del 1%
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};